import { api } from '../services/api';
import { clearButtonLoading, setButtonLoading } from '../functions/events';
import { createAlert, removeAlerts } from '../functions/messages';

const form = document.getElementById('contact-form');
const emailInput = document.getElementById('contact-form__email');
const bodyInput = document.getElementById('contact-form__body');
const submitButton = document.getElementById('contact-form__submit');

form.addEventListener('submit', async (e) => {
    e.preventDefault();

    setButtonLoading(submitButton);
    removeAlerts(form);

    api
        .post(
            '/contact',
            {
                email: emailInput.value,
                body: bodyInput.value,
            },
        )
        .then((response) => {
            if (response.data && response.data.success) {
                const alert = createAlert('success', response.data.message);
                form.append(alert);
                // Keep the submit button disabled to prevent duplicate submissions.
                // Timeout so this happens after the finally.
                setTimeout(() => {
                    submitButton.disabled = true;
                }, 10);
            }
        })
        .catch((err) => {
            const alert = createAlert('danger', err.message);
            form.append(alert);
        })
        .finally(() => {
            clearButtonLoading(submitButton);
        });
});

if (emailInput) {
    emailInput.focus();
}
